export default __webpack_public_path__ + "static/media/qna-messages.f1a10ea4.svg";